<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_4"></a>This book is dedicated to everyone who has ever told or enjoyed a good fishing tale. After all, when the fish aren’t cooperating, a good story may be all we have left!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4ed29210